import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function LatestNewsSection(): JSX.Element {
  return (
    <MDBox py={6} textAlign="center">
      <MDTypography variant="h1">Latest News Section</MDTypography>
    </MDBox>
  );
}

export default LatestNewsSection;
